import React from 'react';

export const LineProgress: React.FC<{ percentage: number; showText?: boolean }> = ({ 
  percentage, 
  showText = true 
}) => {
  const color = percentage === 100 ? '#96c36d' : percentage > 0 ? '#475763' : '#ebebeb';
  
  return (
    <div className="flex flex-col gap-2 w-full min-w-[100px]">
      {showText && (
        <div className="flex justify-between items-center">
          <span className={`text-[10px] font-bold ${percentage === 100 ? 'text-[#96c36d]' : 'text-slate-400'}`}>
            {percentage}%
          </span>
        </div>
      )}
      <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
        <div 
          className="h-full transition-all duration-1000 ease-out rounded-full" 
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
};
